import Vue from "vue";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/build/css/mdb.css";
import "hooper/dist/hooper.css";
import App from "./App.vue";
import Admin from "./views/Admin.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import "./registerServiceWorker";
import "./assets/custom.scss";
import firebase from "./Firebase";
import VueAnalytics from "vue-analytics";
import routes from "./routes";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Antd from "ant-design-vue";
import Sticky from "vue-sticky-directive";
import moment from "moment";
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

Vue.use(Sticky);

//used to replace seconds to human format
Vue.filter("timeInHours", function(value) {
  let hours = parseInt(Math.floor(value / 360));
  let minutes = parseInt(Math.floor((value - hours * 360) / 60));
  let seconds = parseInt((value - (hours * 360 + minutes * 60)) % 60);

  let dHours = hours > 0 ? hours.toString() : "";
  let dMins = minutes >= 0 ? minutes.toString() : "";
  let dSecs = seconds > 9 ? seconds : "0" + seconds;
  let sep1 = hours > 0 ? ":" : "";

  return dHours + sep1 + dMins + ":" + dSecs;
});

Vue.filter("datetimemomentLLL", function(value) {
  return moment(value.seconds * 1000).format("LLL");
});
Vue.filter("datetimemomentLT", function(value) {
  return moment(value.seconds * 1000).format("LT");
});

import Scrollspy from "vue2-scrollspy";
// use default options
Vue.use(Scrollspy);
//import Sortable from 'vue-sortable'

Vue.config.productionTip = false;
let app = "";

//const router = new VueRouter({ routes }) //hash mode, popular in SPA
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}); //html5 history mode

router.beforeEach((to, from, next) => {
  // const currentUser = firebase.auth().currentUser //without Vuex
  const user = store.getters.getUser;
  //console.log('main.js: user from store: ' + user);

  const assessmentidparam = store.getters.getAssessmentIdParam;
  //console.log('main.js: assessmentidparam from store: ' + assessmentidparam);

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !user) next("welcome");
  else next();
});

// use ga
Vue.use(VueAnalytics, {
  id: "UA-140900135-1",
  router,
  debug: {
    enabled: false
  }
});
Vue.use(VueRouter);
Vue.use(CKEditor);
Vue.use(require("vue-moment"));
Vue.use(Antd);
//Vue.use(Sortable)

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    console.log("main.js: onAuthStateChanged fired, user is ");
    console.log(user);
    store.commit("setUser", user);

    //console.log('user comitted to store, getter says ' + this.$store.getters.getUser());
  } else {
    console.log("main.js: onAuthStateChanged fired, user gives false ");
  }

  if (!app) {
    //debug('debug function will now create the app');
    // console.log(router.currentRoute);

    app = new Vue({
      // el: '#app',
      router,
      store,
      render: h => h(App)
    }).$mount("#app");

    //ga regular
    // if (ga) {

    //   ga('set', 'page', router.currentRoute.path);
    //   ga('send', 'pageview');
    //   router.afterEach((to, from) => {
    //     ga('set', 'page', to.path);
    //     ga('send', 'pageview');
    //   });
    // }
  }
});

Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

/*
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://aa4b922e0e914f5d87490f62734dc001@sentry.io/1799755',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});
*/
